var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 20.1666H14.25C18.8333 20.1666 20.6667 18.3333 20.6667 13.75V8.24998C20.6667 3.66665 18.8333 1.83331 14.25 1.83331H8.75C4.16666 1.83331 2.33333 3.66665 2.33333 8.24998V13.75C2.33333 18.3333 4.16666 20.1666 8.75 20.1666Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21916 13.2825L9.40083 10.45C9.7125 10.0467 10.29 9.97336 10.6933 10.285L12.3708 11.605C12.7742 11.9167 13.3517 11.8434 13.6633 11.4492L15.7808 8.71753",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.a7da57784ab97991879000a730ea4cc8.svg";
export { ForwardRef as ReactComponent };